/* eslint-disable @typescript-eslint/no-explicit-any */
type KeyType = any

function objectToMap<T>(obj: Record<KeyType, T>): Map<KeyType, T> {
  const map = new Map<KeyType, T>()
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      map.set(key, obj[key])
    }
  }
  return map
}

const getFirstItemInMap = <KeyType, ValueType>(
  map: Map<KeyType, ValueType>
): [KeyType, ValueType] | undefined => {
  return map.entries().next().value
}
const getFirstKeyInMap = <KeyType, ValueType>(
  map: Map<KeyType, ValueType>
): KeyType | undefined => {
  const firstEntry = map.entries().next().value
  return firstEntry ? firstEntry[0] : undefined
}
const getFirstValueInMap = <KeyType, ValueType>(
  map: Map<KeyType, ValueType>
): ValueType | undefined => {
  const firstEntry = map.entries().next().value
  return firstEntry ? firstEntry[1] : undefined
}

const getLastItemInMap = <KeyType, ValueType>(
  map: Map<KeyType, ValueType>
): [KeyType, ValueType] | undefined => {
  const entries = Array.from(map)
  return entries[map.size - 1]
}

const getLastKeyInMap = <KeyType, ValueType>(map: Map<KeyType, ValueType>): KeyType | undefined => {
  const entries = Array.from(map)
  return entries[map.size - 1]?.[0]
}

const getLastValueInMap = <KeyType, ValueType>(
  map: Map<KeyType, ValueType>
): ValueType | undefined => {
  const entries = Array.from(map)
  return entries[map.size - 1]?.[1]
}

export {
  objectToMap,
  getFirstValueInMap,
  getFirstItemInMap,
  getFirstKeyInMap,
  getLastItemInMap,
  getLastKeyInMap,
  getLastValueInMap
}
